<script>
import DashboardCol from './DashboardCol.vue';

export default {
    name: 'DashboardRow',
    components: { DashboardCol },
};
</script>

<template>
    <div class="row dashboard-row">
        <slot />
    </div>
</template>
